<template>
  <div id="wind-hazard-getting-started">
    <TheTopBar showUser />

    <div class="row">
      <InfoCards :data-info-cards="infoCardsData" />
    </div>
  </div>
</template>
<script>
import store from "@/store";
import TheTopBar from "@/components/TheTopBar";
import InfoCards from "@/components/TheSurveysGettingStartedInformation";
import { mapState } from "vuex";
export default {
  name: "FloodHazardGettingStarted",
  components: {
    TheTopBar,
    InfoCards,
  },
  props: {},
  data() {
    return {
      infoCardsData: [
        {
          title: "Flood Hazard",
          description:
            "The expected impact to your home during a flood event depends on the location of your house and characteristics of your surrounding community as well as characteristics of your land and the house itself, among other factors. Answer the questions and complete the checklists below to think through the expected impact to your home today from a flood event of similar magnitude to the 2013 Christmas Eve Trough.",
          buttonText: "Next",
          cardClass: "",
          wrapperClass: "col s12",
          route: "",
        },
        {
          title: "Lets Get Started",
          description:
            "The checklists should also help you think about measures you can put in place to make your home more resilient to floods. ",
          buttonText: "Click To Begin",
          cardClass: "",
          wrapperClass: "col s12",
          route: "FloodHazardSurvey",
        },
      ],
    };
  },
  created() {
    //if (this.surveyStarted) this.$router.push({ name: "FloodHazardSurvey" });
  },
  mounted() {
    // this.$router.push({ name: "WindHazardSurvey" });
  },
  computed: {
    ...mapState({
      surveyStarted: (state) => state.Surveys.floodHazardStarted,
    }),
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
#wind-hazard-getting-started {
}
</style>
